export default __webpack_public_path__ + "static/media/NC.f23511ea.svg";